<!-- =========================================================================================
File Name: App.vue
Description: Main vue file - APP
----------------------------------------------------------------------------------------
Item Name: Vuesax Admin - VueJS Dashboard Admin Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="app">
        <router-view ></router-view>
    </div>
</template>

<script>
//load configurations on theme
import themeConfig from '@/../themeConfig.js';

// import axios
import axios from 'axios';  

export default {
    data: function() {
        return {
            hoteis: [],
        }
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val);
        },
        '$route' (new_val, old_val) {
            this.checkVersion();
        }
    },
    async created() {
        try {        
            if (this.$auth) {
                await this.$auth.renewTokens();
            }
        } catch (e) {
            console.log(e);
        }
    },
    methods: {
        toggleClassInBody(className) {
            if (className == 'dark') {
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                document.body.classList.add('theme-dark');
            } else if (className == 'semi-dark') {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                document.body.classList.add('theme-semi-dark');
            } else {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
            }
        },
        handleWindowResize(event) {
            this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
        },
        checkVersion: function() {
            axios({
                method: 'get',
                url: '/version.txt?_=' +new Date().getTime(),
            }).then(function (resp) {
                if(localStorage.getItem('version') != resp.data) {
                    localStorage.setItem('version', resp.data);
                    window.location.reload(true);
                }
            }).catch( function (err) {
                console.log('error getting version');
            });
        },
    },
    mounted() {
        this.toggleClassInBody(themeConfig.theme)
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleWindowResize);
        });
        this.$store.dispatch('updateWindowWidth', window.innerWidth);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    },
}

</script>
<style>
    @media only screen and (max-width: 770px) {
        .selectWidth{
            min-width: 150px;
        }
    }

    .vs-notifications h3{
        padding: 0 !important;
    }
    .vdp-datepicker__calendar .cell.selected {
        background: rgb(var(--vs-primary)) !important;
    }   
    .vdp-datepicker__calendar .cell:hover, .vdp-datepicker__calendar .cell.selected:hover {
        color: #FFF !important;
        border-color: rgb(var(--vs-primary)) !important;
        background-color: rgb(var(--vs-primary)) !important;
    }
    .vdp-datepicker__calendar header span {
        color: rgb(var(--vs-primary));
    }
    .selectWidth{
        min-width: 250px;
    }
    .selectWidth200{
        min-width: 200px;
    }
    .selectWidth300{
        min-width: 300px;
    }
    .selectWidth360{
        min-width: 360px;
    }
    .selectWidth460{
        min-width: 460px;
    }
    .con-pagination-table.vs-table--pagination .vs-row{
        display: flex !important;
        justify-content: flex-end !important;
    }

    .vdp-datepicker input {
        max-width: 350px;
        width: 100% !important;
    }
    
    .full-width,
    .full-width .vs-con-input {
        width: 100% !important;
    }
</style>